exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".readonly-input{pointer-events:none;color:#666;border-color:#efefef}", ""]);

